import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { IModalBase } from '@interfaces/commonInterfaces'
import moment from 'moment'

export interface InitState {
  userList: any
  userOptionList?: any
  userDetail?: any
  reloadUserList?: string | null
  modalUser?: IModalBase

  userListRole: any
  projectList: any
  reloadUserDetail?: string | null
}

const initialState: InitState = {
  userList: [],
  userOptionList: [],
  userDetail: {},
  reloadUserList: null,
  modalUser: {
    visible: false,
    record: {}
  },
  userListRole: [],
  projectList: [],
  reloadUserDetail: null,
}

export const userDucks: any = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state: RootState) => {
      state.responseLogin = { loading: true, error: false }
    },
    loginSuccess: (state: RootState, { payload: responseLogin }) => {
      state.responseLogin = {
        loading: false,
        error: false,
        response: responseLogin,
      }
    },
    loginFail: (state: RootState, { payload: error }) => {
      state.responseLogin = {
        loading: false,
        error: true,
        response: error,
      }
    },

    getListUser: (state: RootState) => {
      state.userList = { loading: true }
    },
    getListUserSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.userList = { loading: false, ...action.payload }
    },
    getListUserFail: (state: RootState, action: PayloadAction<any>) => {
      state.userList = { loading: false, ...action.payload }
    },

    getListOptionUser: (state: RootState) => {
      state.userOptionList = { loading: true }
    },
    getListOptionUserSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.userOptionList = { loading: false, ...action.payload }
    },
    getListOptionUserFail: (state: RootState, action: PayloadAction<any>) => {
      state.userOptionList = { loading: false, ...action.payload }
    },

    getDetailUser: (state: RootState, action: PayloadAction<any>) => {
      state.userDetail = { loading: true, id: action.payload }
    },
    getDetailUserSuccess: (state, action: PayloadAction<any>) => {
      state.userDetail = { loading: false, ...action.payload }
    },
    getDetailUserFail: (state, action: PayloadAction<any>) => {
      state.userDetail = { loading: false, ...action.payload }
    },

    setReloadUserList: (state: RootState) => {
      state.reloadUserList = String(moment())
    },
    setModalUser: (state, action: PayloadAction<IModalBase>) => {
      state.modalUser = action.payload
    },


    getListRole: (state: RootState) => {
      state.roleList = { loading: true }
    },
    getListRoleSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.roleList = { loading: false, ...action.payload }
    },
    getListRoleFail: (state: RootState, action: PayloadAction<any>) => {
      state.roleList = { loading: false, ...action.payload }
    },


    getListProject: (state: RootState) => {
      state.projectList = { loading: true }
    },
    getListProjectSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.projectList = { loading: false, ...action.payload }
    },
    getListProjectFail: (state: RootState, action: PayloadAction<any>) => {
      state.projectList = { loading: false, ...action.payload }
    },

    setReloadUserDetail: (state: RootState) => {
      state.reloadUserDetail = String(moment())
    },


  },
})

// Action creators are generated for each case reducer function
export const {
  login,
  loginSuccess,
  loginFail,

  getListUser,
  getListUserSuccess,
  getListUserFail,

  getListOptionUser,
  getListOptionUserSuccess,
  getListOptionUserFail,

  getDetailUser,
  getDetailUserSuccess,
  getDetailUserFail,

  setReloadUserList,
  setModalUser,

  getListRole,
  getListRoleSuccess,
  getListRoleFail,

  getListProject,
  getListProjectSuccess,
  getListProjectFail,

  setReloadUserDetail,
} =
  userDucks.actions

export default userDucks.reducer
